import React from "react";
import "./styles/SaaSDtOverView.scss";
import { useTranslation } from "react-i18next";

const SaaSDtOverView = () => {
  const { t } = useTranslation();
  const contents = t("digitalTwin.saasDt.contents.overview", { returnObjects: true }) as {
    name: string;
    list: string[];
  }[];
  return (
    <>
      <div className="saas_dt_overview_wrap">
        <h2 className="title">{t("digitalTwin.saasDt.title")}</h2>
        <div className="overview">
          <h3 className="sub_title">{t("digitalTwin.saasDt.sub")}</h3>
          <div className="card_wrap">
            {contents.map((content: { name: string; list: string[] }, index: number) => {
              return (
                <div className="card" key={`${content.name}_${index}`}>
                  <div className="name">{content.name}</div>
                  <ul>
                    {content.list.map((text: string, index: number) => {
                      return <li key={`${text}_${index}`}>{text}</li>;
                    })}
                  </ul>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default SaaSDtOverView;
